import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Callback
import { CallbackComponent } from './callback/callback.component';

// Invalid
import { InvalidPageComponent } from './misc/invalid-page/invalid-page.component';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout.component';

// Auth Guard
import { AuthGuardService as AuthGuard } from './auth/auth-guard.service';
import { RoleGuardService as RoleGuard } from './auth/role-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: FullLayoutComponent,
    data: {
      title: 'Home'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './views/dashboard/dashboard.module#DashboardModule',
        canActivate: [RoleGuard],
        data:{
          role: [
            'Dealer', 
            'HeadOffice-AHM',
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'monthly_report',
        loadChildren : './views/monthly-report/report-type/report-type.module#ReportTypeModule',
        canActivate: [RoleGuard],
        data:{
          role: [
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'mapping',
        loadChildren : './views/monthly-report/map-report-type/map-report-type.module#MapReportTypeModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'download_report_dealer',
        loadChildren : './views/monthly-report/download-monthly-report/download-monthly-report.module#DownloadMonthlyReportModule',
        canActivate: [RoleGuard],
        data:{
          role: [
            'HeadOffice-AHM',
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'download',
        loadChildren : './views/monthly-report/download-template-monthly-report/download-template-monthly-report.module#DownloadTemplateMonthlyReportModule',
        canActivate: [RoleGuard],
        data:{
          role: [
            'Dealer'
          ]
        }
      },
      {
        path : 'bonus_template',
        loadChildren : './views/bonus/bonus-template/bonus-template.module#BonusTemplateModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'mapping_bonus_template',
        loadChildren : './views/bonus/mapping-bonus-template/mapping-bonus-template.module#MappingBonusTemplateModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      },
      {
        path : 'calculate_bonus',
        loadChildren : './views/bonus/bonus-calculation/bonus-calculation.module#BonusCalculationModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'MainDealer-Staff'
          ]
        }
      },
      {
        path:'user-managements',
        loadChildren:'./views/user-management/user-management-roles/user-management-roles.module#UserManagementRolesModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'SuperAdmin'
          ]
        }
      },
      {
        path:'upload',
        loadChildren:'./views/monthly-report/upload-monthly-report-dealer/upload-monthly-report-dealer.module#UploadMonthlyReportDealerModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'Dealer'
          ]
        }
      },
      {
        path:'verify',
        loadChildren:'./views/bonus/verify-bonus-calculation/verify-bonus.module#VerifyBonusModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'SuperAdmin'
          ]
        }
      },
      {
        path:'edit',
        loadChildren:'./views/bonus/edit-and-publish/edit-and-publish.module#EditAndPublishModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-AHM',
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'SuperAdmin'
          ]
        }
      },
      {
        path:'download_final_bonus',
        loadChildren:'./views/bonus/download-final-bonus/download-final-bonus.module#DownloadFinalBonusModule',
        canActivate: [RoleGuard],
        data:{
          role: [ 
            'HeadOffice-AHM',
            'HeadOffice-Management',
            'HeadOffice-Marketing',
            'MainDealer-Management',
            'MainDealer-Staff',
            'SuperAdmin'
          ]
        }
      }
    ],
  },
  {
    path : 'callback/:token',
    component : CallbackComponent,
    data: {}
  },
  {
    path: 'invalid_page',
    component : InvalidPageComponent,
    data: {}
  }

];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/app/app.routing.ts